let $searchBarInput,
    $searchSuggestions,
    $searching,
    $currentSearchedValue;

$(document).ready(function ($) {
    $searchBarInput = $('.js-search-bar');
    $searching = false;
    $searchSuggestions = $('.js-suggestionbox');


    $searchBarInput.keyup(function(){
        $currentSearchedValue = $(this).val();
        if(!$searching){
            $searching = true;
            getRecipes($(this).val());
        }

    })
});



function getRecipes(inputValue){


    $.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'search_recipes',
            search_value: inputValue,
        },
        dataType: 'json',
        success: function (response) {
            showSuggestions(response, inputValue);
            $searching = false;
            if(inputValue !== $currentSearchedValue){
                getRecipes($currentSearchedValue);
            }
        },
        error: function (response) {
            $searching = false;
            console.log('error', response);
        }
    });
}


function showSuggestions(posts, usedValue){
    let suggestionsHtml = ''
    posts.forEach((post) => {
        let postTitle = post.post_title;
        const boldString = postTitle.replace(usedValue, '<b>' + usedValue + '</b>');
        const postUrl = post.guid;
        suggestionsHtml += '<a href="'+postUrl+'" class="d-block">'+boldString+'</a>'
    })

    $searchSuggestions.html(suggestionsHtml);
}
